// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"1472da95","828":"db552c39"}[chunkId] + ".chunk.js";
};